import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { debounceTime, Subject, Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { EntitySummaryModel, EntitySummaryPayloadModel, EntitySummaryResponseModel } from 'src/app/model/shared/components/entities/entities-profile/entities-widgets-collection/entity-summary';
import { GeneralService } from 'src/app/services/general.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-entity-summary',
  templateUrl: './entity-summary.component.html',
  styleUrls: ['./entity-summary.component.css']
})
export class EntitySummaryComponent implements OnInit, OnDestroy {
  private updateInputs$ = new Subject<void>();

  @Input()
  set entityId(value: string) {
    this._entityId = value;
    this.updateInputs$.next();
  } 

  @Input()
  set fromDate(value: any) {
    this._fromDate = value;
    this.updateInputs$.next();
  } 

  @Input()
  set toDate(value: any) {
    this._toDate = value;
    this.updateInputs$.next();
  }

  get entityId() {
    return this._entityId;
  }
  _fromDate: any;
  _toDate : any;

  // Data
  readonly MESSAGES = Messages;
  summary: EntitySummaryModel;
  private _entityId: string;
  public trlConfig : any;

  // Subscription
  private _entitySummarySubscription: Subscription;

  constructor(
    private _entitiesService: EntitiesServiceService,
    private _generalService: GeneralService,
    private _datePipe: DatePipe,
    private _apiService: ServicecallService
  ) {
    this.updateInputs$
      ?.pipe(debounceTime(50)) 
      ?.subscribe(() => {
        this._setEntitySummary();
      });
   }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._entitySummarySubscription?.unsubscribe();
  }

  private _setEntitySummary() {
    let configStartDate = null;
    let configEndDate = null;
    this.trlConfig = this._apiService?.getConfiguration('tenantGenericConfig') ? this._apiService?.getConfiguration('tenantGenericConfig') : null;

    if (this.trlConfig?.defaultTimeRange) {
      const configHour = this.trlConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this._apiService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const [startTime, endTime] = this._generalService?.getStartEndTimeByDate();
    const _filterPayload: EntitySummaryPayloadModel = {
      entityId: this.entityId,
      from: this._datePipe.transform(this._fromDate ?? (configStartDate ?? startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ')
    };
    this._entitySummarySubscription = this._entitiesService.getEntitySummary(_filterPayload)
    .subscribe({
      next: (result: EntitySummaryResponseModel) => {
        this.summary = {
          timeTaken: this._apiService.getConfiguration('tenantGenericConfig')?.timeTakenIn === 'hr' ? (result?.timeTakenInMin * 3600) : (result?.timeTakenInMin * 60), // Converts hr/minute to second
          distance: (result?.distanceTravelled) 
        }
      },
      error: (errorResponse: HttpErrorResponse) => {
        this._apiService.toasterService({ type: 'Error', msg: errorResponse?.error?.response?.message });
      }
    });
  }

}
